import {urlToData} from "@commons/infra/helpers";

export let qagameTermsAndConditionsUrl = () => urlToData('documents/lv/Konkursa-noteikumi-2024-09.pdf');

export let PrizeUtils = {
    isMedonPromocode: (prizeId) => {
        return prizeId.startsWith('')
    }
}
